export class TransactionsResponse {
    amount: number;
    consumerId: string;
    convenienceFee: number;
    createdAt: string;
    id: string;
    status: string;
    paymentChannel: string;
    transactionDetails: TransactionDetails;
    transactionItemId: string;
    verificationStatus: string;
    walletId: string;
    walletTransactionType: string;
}

export class TransactionPatchRequest {
    verificationStatus: string;
}

export class TransactionDetails {
    id: string;
    referenceNumber: string;
    manualPaymentType: string;
    amount: string;
    paymentDate: string;
    payerName: string;
}

export class
    ManualTransactionRequestModel {
    orderId: string;
    consumerId: string;
    referenceNumber: string;
    manualPaymentType: string;
    amount: number;
    paymentDate: string;
    payerName: string;
    paymentMode: string;
    exchangeBankId: string;
}
export class ManualPaymentRequest {
    orderId: string;
    consumerId: string;
    referenceNumber: string;
    manualPaymentType: string;
    amount: number;
    paymentDate: any;
    payerName: string;
    paymentMode: 'CASH';
    paymentProof: 'NOTHING';
}

export class CancelOrderRequest {
    cancellationMessage: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/transactions/transactions.ts